
import React from "react";

interface LoginPromptProps {
  text: string;
  linkText: string;
  onClick: () => void;
}

const LoginPrompt: React.FC<LoginPromptProps> = ({ text, linkText, onClick }) => {
  return (
    <p className="text-center text-sm text-gray-500 mt-6">
      {text}{" "}
      <button
        type="button"
        onClick={onClick}
        className="text-grandpal-green hover:underline font-medium"
      >
        {linkText}
      </button>
    </p>
  );
};

export default LoginPrompt;

